import { render, staticRenderFns } from "./reference-sidesheet.vue?vue&type=template&id=39218582&scoped=true&"
import script from "./reference-sidesheet.vue?vue&type=script&lang=js&"
export * from "./reference-sidesheet.vue?vue&type=script&lang=js&"
import style0 from "./reference-sidesheet.vue?vue&type=style&index=0&id=39218582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39218582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39218582')) {
      api.createRecord('39218582', component.options)
    } else {
      api.reload('39218582', component.options)
    }
    module.hot.accept("./reference-sidesheet.vue?vue&type=template&id=39218582&scoped=true&", function () {
      api.rerender('39218582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/reference-components/reference-sidesheet.vue"
export default component.exports